module.exports = __webpack_public_path__ + "img/icon_fingerprint.2fdeca66.png";